import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init())
    } else {
      this.init()
    }
  }

  init() {
    if (!window.gsap || !window.ScrollTrigger) return

    window.gsap.registerPlugin(window.ScrollTrigger)
    this.initHeroTimeline()
    this.initScrollReveal()
    this.initHeroParallax()
  }

  disconnect() {
    if (window.ScrollTrigger) {
      window.ScrollTrigger.getAll().forEach(trigger => trigger.kill())
    }
  }

  initHeroTimeline() {
    const gsap = window.gsap
    if (!gsap) return

    const badge = document.querySelector('.badge-spotify')
    const title = document.querySelector('.hero-spotify h1')
    if (!badge || !title) return

    const tl = gsap.timeline({ defaults: { ease: "power3.out" } })
    tl.from('.badge-spotify', { opacity: 0, y: 20, duration: 0.6 })
      .from('.hero-spotify h1', { opacity: 0, y: 30, duration: 0.8 }, "-=0.3")
      .from('.hero-spotify .subtitle', { opacity: 0, y: 20, duration: 0.6 }, "-=0.4")
      .from('.stat-spotify', { opacity: 0, y: 20, duration: 0.6 }, "-=0.3")
      .from('.hero-spotify .btn-spotify-green, .hero-spotify .btn-spotify-outline', { opacity: 0, y: 20, scale: 0.9, duration: 0.6, stagger: 0.1 }, "-=0.3")
  }

  initScrollReveal() {
    if (!window.gsap || !window.ScrollTrigger) return
    const gsap = window.gsap

    const cards = document.querySelectorAll('.card, .project-card, .exp-card')
    cards.forEach((card, index) => {
      gsap.from(card, {
        scrollTrigger: { trigger: card, start: "top 85%", toggleActions: "play none none reverse" },
        y: 50, opacity: 0, duration: 0.8, ease: "power2.out", delay: index * 0.05
      })
    })

    const sections = document.querySelectorAll('section')
    sections.forEach(section => {
      if (section.querySelector('.animate-fade-in')) return
      const elements = section.querySelectorAll('h2, h3, p, .btn-primary, .btn-spotify-green')
      if (elements.length === 0) return
      gsap.from(elements, {
        scrollTrigger: { trigger: section, start: "top 80%", toggleActions: "play none none reverse" },
        y: 30, opacity: 0, duration: 0.6, stagger: 0.1, ease: "power2.out"
      })
    })
  }

  initHeroParallax() {
    if (!window.gsap || !window.ScrollTrigger) return
    const heroImage = document.querySelector('.hero-spotify-image')
    if (heroImage) {
      window.gsap.to(heroImage, {
        scrollTrigger: { trigger: '.hero-spotify', start: "top top", end: "bottom top", scrub: 1 },
        y: 200, ease: "none"
      })
    }
  }
}
